var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ disabled: _vm.disabled },style:({
		userSelect: 'none',
		WebkitUserSelect: 'none',
		MozUserSelect: 'none',
		msUserSelect: 'none',
	}),on:{"click":_vm.click}},[(!_vm.simple)?_c('div',{staticClass:"switch"},[(!_vm.value)?_c('img',{staticClass:"switch-icon",attrs:{"src":require("../assets/Switch.png"),"alt":""}}):_c('img',{staticClass:"switch-icon",attrs:{"src":require("../assets/SwitchOpen.png"),"alt":""}})]):_c('div',{staticClass:"switch-simple"},[(!_vm.value)?_c('img',{staticClass:"switch-icon",attrs:{"src":require("../assets/Switch-simple.png"),"alt":""}}):_c('img',{staticClass:"switch-icon",attrs:{"src":require("../assets/SwitchOpen-simple.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }